<template>
  <div class="yunxiao teacher course-multi-edit" data-test="course-multi-edit">
    <div class="top-filter">
      <van-dropdown-menu active-color="var(--c1)">
        <van-dropdown-item 
          v-model="params.weekDay" 
          :options="daysOption" 
          :title="!params.weekDay?'星期':''"/>
        <van-dropdown-item 
          v-model="params.teacherId" 
          :options="teachersOption" 
          :title=" !params.teacherId ? '老师' : '' "/>
        <van-dropdown-item 
          v-model="params.classRoomId" 
          :options="roomsOption" 
          :title=" !params.classRoomId ? '教室' : '' "/>
      </van-dropdown-menu>
    </div>
    <div class="sub-top-nav">
      <div 
        class="choose-date" 
        @click="rangeCalendarShow=true">
        {{dataRange[0]|formatDatetime}}至{{dataRange[1]|formatDatetime}}
        <van-icon name="system_choose" class-prefix="vxs-icon" :color="'var(--g4)'" />
      </div>
      <div class="time-range" @click="pickerTimeRange" >
        <van-icon 
          name="clear" 
          v-if="params.startTime" 
          @click.stop="clearTimeRange"
          :color="'var(--g4)'" />
        {{
          params.startTime ? (params.startTime +'-' + params.endTime):'时段选择'
        }}
        <van-icon name="system_choose" class-prefix="vxs-icon" :color="'var(--g4)'" />
      </div>
    </div>
    <vx-list
      class="course-list"
      :api="api"
      :params="params"
      @load="onLoad"
      ref="vxList"
      :pageSize="1000"
      firstShowLoading>
      <empty-page 
        v-if="!dataLoading && list.length === 0"
        :show="true"
        :tips="hasFliter ? '没有符合条件的排课': '无数据'"
        :isNoResult="hasFliter"
         />
      <template v-else >
        <div
          class="course-item"
          :key="item.id"
          :time-out="item.signNum"
          v-for="item in list"
        >
          <div class="title">
            <span class="bold">
              <span>{{ item.startTime | formatDatetime("MM-dd") }}</span>
              <span>（{{item.startTime | getWeek}}）</span>
            </span>
            <span>
              <span>{{ item.startTime | formatDatetime("hh:mm") }}～</span>
              <span>{{item.endTime | formatDatetime("hh:mm")}}</span>
              <span> · {{ item.courseAmount }}{{lessonUnit}}</span> 
            </span>
          </div>
          <div class="infos-nav">
            <div class="infos">
              <div v-if="item.courseArrangeTeacherVoList && item.courseArrangeTeacherVoList.filter(v=>v.teacherRule === 0).length>0">
                <van-icon name="contact" />{{item.courseArrangeTeacherVoList.filter(v=>v.teacherRule === 0).map(v=>v.teacherName).join("、")}}
              </div>
              <div v-if="item.classRoomName">
                <van-icon name="location-o" />{{ item.classRoomName }}
              </div>
            </div>
            <div class="status" v-if="item.courseStatus == 1">
              签到: {{ item.signNum }}/{{ item.signTotalNum }}
            </div>
            <div class="status" v-else-if="item.courseStatus == 2">
              已取消
            </div>                
            <div
              class="status no-call"
              v-else-if="item.timeOut == 1 && item.courseStatus == 0"
            >
              未签到
            </div>
          </div>
          <van-checkbox 
            v-model="item.checked" 
            :disabled="!!item.signNum"
            icon-size="var(--fs-lg)" 
            label-disabled></van-checkbox>
        </div>
      </template>
    </vx-list>
    <div class="multi-edit-page-footer">
      <div class="status-nav">
        <div class="total-num">
          <span>共<span>{{totalCount}}</span>节,{{canChoosedNum}}节可选</span>
          <van-popover
            v-model="showPopover"
            trigger="click"
            placement="top-start"
            theme="dark"
            :offset="[-10,20]"
          >
            已过期排课、已取消排课和已签到排课，不可批量编辑。
            <template #reference>
              <van-icon name="question-o"  style="vertical-align: middle;" />
            </template>
          </van-popover>
        </div>
        <div class="choosed-status">
          <span class="choosed-num" >已选<span>{{choosedNum}}</span>节</span>
          <div class="checked-nav">
            全选<van-checkbox @change="allCheckBoxChange" v-model="allChecked" icon-size="var(--fs-lg)" label-disabled></van-checkbox>
          </div>
        </div>
      </div>
      <page-footer-btn multipleBtns>
        <van-button square round block @click="cancleMultiEdit" data-test="course-multi-edit-btn-cancle">
          返回
        </van-button>
        <van-button square round block type="primary" @click="doMultiEdit" data-test="course-multi-edit-btn-do">
          批量编辑
        </van-button>
      </page-footer-btn>
    </div>

    <van-calendar 
      v-model="rangeCalendarShow" 
      :default-date="dataRange"
      :allow-same-day="true"
      :maxDate="maxDate"
      :minDate="minDate"
      type="range" 
      @confirm="onConfirm" />
    
    <!-- 排课操作列表 -->
    <van-action-sheet 
      v-model="showOperation" 
      :actions="operationActions" 
      cancel-text="取消" 
      close-on-click-action 
      @cancel="showOperatio=false"
      @select="onSelectOperation"/>
    <!-- 删除排课弹窗 -->
    <van-dialog v-model="showDeleteDialog" title="提示" :showConfirmButton="false">
      <div class="delete-dialog">
        <div class="top-tips">删除后排课不能恢复，是否要删除{{this.choosedNum}}节排课？</div>
        <van-button 
          block 
          type="default" 
          @click="confirmDelete" 
          size="large" 
          style="color: var(--c3)"
          class="van-dialog__confirm van-hairline--top">
          继续删除
        </van-button>
        <!-- <van-button 
          block 
          type="default" 
          @click="toStopCourse" 
          size="large" 
          style="color: var(--g8)" 
          class="van-dialog__confirm van-hairline--top">取消排课</van-button> -->
        <van-button 
          block 
          type="default" 
          @click="showDeleteDialog=false" 
          size="large" 
          style="color: var(--g8)"
          class="van-dialog__confirm van-hairline--top">取消</van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import emptyPage from "@teacher/components/empty-page.vue";
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";

const initParams = {
  teacherId: '',      
  weekDay: '',
  classRoomId: '',
  startDate: '',
  endDate: '',
  startTime: '',
  endTime: '',
}

export default {
  name: 'ClassMultiEdit',
  components: {
    pageFooterBtn,
    emptyPage,
  }, 
  filters: {
    formatDatetime (v, reg = 'yyyy-MM-dd') {
      return app.tool.date.formatDatetime(v, reg);
    }
  },
  data () {
    return {
      pageTitle: '批量编辑',
      list: [],
      courseInfos: {},
      minDate: new Date(),
      maxDate: new Date(),
      dataRange: [],
      daysOption: [
        { text: '不限', value: '' },
        { text: '星期一', value: 1 },
        { text: '星期二', value: 2 },
        { text: '星期三', value: 3 },
        { text: '星期四', value: 4 },
        { text: '星期五', value: 5 },
        { text: '星期六', value: 6 },
        { text: '星期日', value: 7 },
      ],
      roomsOption: [
        { text: '全部教室', value: '' },
      ],
      teachersOption: [
        { text: '全部老师', value: '' },
      ],
      params: {
        classId: '',
        teacherId: '',
        weekDay: '',
        classRoomId: '',
        startDate: '',
        endDate: '',
        startTime: '',
        endTime: '',
      },
      rangeCalendarShow: false,
      showOperation: false,
      showDeleteDialog: false,
      allChecked: false,
      showPopover: false,
      dataLoading: false,
      api: this.$api.getArrangeList,
      totalCount: ''
    }
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
    choosedList () {
      return this.list.filter(v=>v.checked);
    },
    canChoosedList () {
      // 已经取消排课、过期的课程不可选中
      return this.list.filter(v=> v.signNum<=0);
    },
    canChoosedNum () {
      return this.canChoosedList.length;
    },
    choosedNum () {
      return this.choosedList.length;
    },
    arrangeRecordIds () {
      return this.list.filter(v=>v.checked).map(v=>v.id);
    },
    hasFliter () {
      // 判断是否有筛选，有筛选无结果时提示内容不同
      let {weekDay, teacherId, classRoomId, startTime, startDate, endDate} = this.params
      // 星期、教室、开始时段、老师id任一数据有值，表示有设置筛选
      if (weekDay || classRoomId || startTime || teacherId) return true;

      let {courseInfos}=this
      // 开始时间和后台返回的课程开始时间不同，表示有设置筛选
      if (courseInfos.startCourseDate || courseInfos.startCourseDate!==startDate) return true;
      // 结束时间和后台返回的课程结束时间不同，表示有设置筛选
      if (courseInfos.stopCourseDate || courseInfos.stopCourseDate!==endDate) return true;
    },
    operationActions() {
      let actions = [];
      if (app.permission.op('edit_course_arrange')) {
        actions = actions.concat([
          {name: '修改上课时段', id: 1},
          {name: '修改上课日期', id: 2},
          {name: '修改上课老师', id: 4}, 
          {name: '修改助教', id: 9}, 
          {name: '修改上课教室', id: 5}, 
          {name: `修改老师授课${this.lessonUnit}数`, id: 6},
        ])
      }
      if (app.permission.op('edit_course_reserve')) {
        actions.push({name: '修改约课设置', id: 8})
      }
      if (app.permission.op('delete_course_arrange')) {
        actions.push({name: '删除排课', id: 7, color: 'var(--c3)'})
      }
      return actions;
    }
  },
  methods: {
    onLoad(list, res) {
      vant.Toast.clear();
      this.courseInfos = res.data;
      this.totalCount = res.page.totalCount;
      let cclist = res.data && res.data.courseArrangeExtendVoList;
      if (res.page && res.page.pageNum == 1) {
        this.list = cclist || []
      } else {
        Array.isArray(cclist) && this.list.push(...cclist);
      }
      if (res.data.startCourseDate && res.data.stopCourseDate && !this.firstLoaded) {
        // 标记不是第一次加载了，
        // 之后的筛选请求不需要再次设置开始/结束时间
        this.firstLoaded = true;

        this.params.startDate =  res.data.startCourseDate;
        this.minDate = new Date(this.params.startDate.replace(/-/g, '/'));

        this.params.endDate = res.data.stopCourseDate;
        this.maxDate = new Date(this.params.endDate.replace(/-/g, '/'));

        this.dataRange = [this.minDate, this.maxDate];
      }
    },
    // 获取查询参数
    getFilterParas () {
      let parmas = {};
      for (let prop in this.params) {
        if (this.params[prop]) parmas[prop] = this.params[prop];
      }
      return parmas;
    },
    // 获取老师、教室数据进行筛选
    async getFilterData() {
      let getClassRoomList = this.$api.getClassRoomList({campusIds: [this.$route.query.cid]});
      let getTeacherList = this.$api.getTeacherPage({page: {pageNum: 1, pageSize: 99999}});
      try {
        let allAajx = Promise.all([getTeacherList,getClassRoomList]);

        // 查询教室
        getClassRoomList.then((res) => {
          if (res.code === 200) {
            this.roomsOption.push(...res.data.map(item=>{
              return {
                text: item.status ? item.roomName : `${item.roomName}（停用）`,
                value: item.id,
                status: item.status,
              }
            }));
          }
        });

        // 查询老师
        getTeacherList.then((res) => {
          if (res.code === 200) {
            this.teachersOption.push(...res.data.map(item=>{
              return {
                text: item.name,
                value: item.id,
              }
            }));
          }
        });

        await allAajx;

        // 如果没有报异常，返回200
        return 200;
      } catch(err){
        console.error(err)
      }
    },
    // 确认日期范围选择
    onConfirm (v) {
      this.dataRange = v;
      let reg = 'yyyy-MM-dd';
      this.params.startDate = app.tool.date.formatDatetime(v[0], reg);
      this.params.endDate = app.tool.date.formatDatetime(v[1], reg);
      this.rangeCalendarShow = false;
    },
    // 修改时段
    pickerTimeRange () {
      app.x3.picker.timeInterval().then(res=>{
        this.params.startTime = res.value1;
        this.params.endTime = res.value2;
      });
    },
    // 清空时段筛选
    clearTimeRange () {
      this.params.startTime = '';
      this.params.endTime = '';
    },
    // 取消批量纺车
    cancleMultiEdit () {
      this.$router.back();
    },
    doMultiEdit () {
      if (this.choosedNum === 0) {
        this.$toast('至少需要选择一节排课。');
        return false;
      }
      this.showOperation = true;
    },
    allCheckBoxChange (val) {
      // 避免通过点击单个，到达全选状态
      // 还会循环一遍实现选中的问题
      if (val && this.canChoosedNum!==this.choosedNum) {
        this.canChoosedList.forEach(v=> {
          if (v&& !v.checked) {
            this.$set(v, 'checked', val);
          }
        })
      }
      // 取消全选,避免通过点击单个，到达未全选状态
      // 还会循环一遍取消所有选中的问题
      if (!val && this.canChoosedNum === this.choosedNum) {
        this.canChoosedList.forEach(v=> {
          this.$set(v, 'checked', val);
        })
      }
    },
    // 选中操作选项
    // {name: '修改上课时段', id: 1},
    // {name: '批量延后', id: 2}, 
    // {name: '批量取消排课', id: 3}, 
    // {name: '修改上课老师', id: 4}, 
    // {name: '修改上课教室', id: 5}, 
    // {name: '修改老师授课扣除数', id: 6}, 
    // {name: '删除', id: 7, color: 'var(--c3)'}
    onSelectOperation(val) {
      switch (val.id) {
        case 1:
          this.toModifySchedule();
          break;
        case 2:
          this.toDelaySchedule();
          break;
        // case 3:
        //   this.toStopCourse();
        //   break;
        case 4:
          this.toChoiceTeacher();
          break;
        case 5:
          this.modifyClassRoom();
          break;
        case 6:
          this.toModifyAmount();
          break;
        case 7:
          this.showDeleteDialog = true;
          break;
        case 8:
           this.toModifyReserves();
          break;
        case 9:
          this.toChoiceTeacher(true);
          break;
        default:
          break;
      }
    },
    // 确认删除
    confirmDelete() {
      this.showLoading();
      this.$api.batchDelete({courseArrangeIds: this.arrangeRecordIds}).then(res=>{
        if (res.code === 200) {
          vant.Toast.success( "删除成功");
          this.$refs['vxList'] && this.$refs['vxList'].hightReFresh();
          app.vue.$emit("class-paike-add-success");
        }
      })
      this.showDeleteDialog = false;
    },
    // 去修改上课时段
    toModifySchedule() {
      let obj = this.choosedList[0] || {};
      app.ls.set("multi-modify-schedule-obj", {
        courseArrangeIds: this.arrangeRecordIds,
        startTime: app.tool.date.formatDatetime(obj.startTime, 'hh:mm'),
        endTime: app.tool.date.formatDatetime(obj.endTime, 'hh:mm'),
      });
      this.$router.push('/multiModifySchedule');
    },
    // 去延迟
    toDelaySchedule() {
      app.ls.set("multi-delay-schedule-obj", {
        courseArrangeIds: this.arrangeRecordIds,
      });
      this.$router.push('/multiDelaySchedule');
    },
    // 去修改课时
    toModifyAmount() {
      app.ls.set("multi-modify-amount-obj", {
        courseArrangeIds: this.arrangeRecordIds,
        courseAmount: app.tool.safeReadObjProp(this.choosedList, '0.courseAmount'),
      });
      this.$router.push('/multiModifyAmount');
    },
    // 去取消排课
    // toStopCourse() {
    //   app.ls.set("multi-stop-course-obj", {
    //     courseArrangeIds: this.arrangeRecordIds,
    //   });
    //   this.$router.push('/multiStopCourse');
    // },
    // 去修改老师
    toChoiceTeacher(isAssitant) {
      app.ls.set("multi-choice-teacher-obj", {
        courseArrangeIds: this.arrangeRecordIds,
        campusIds: [this.choosedList[0] && this.choosedList[0].campusId],
        multiCourseAssistant: isAssitant,
      });
      this.$router.push('/multiModifyTeacher');
    },
    // 去修改上课教室
    modifyClassRoom() {
      app.ls.set("multi-modify-class-room-obj", {
        courseArrangeIds: this.arrangeRecordIds,
        campusId: app.tool.safeReadObjProp(this.choosedList, '0.campusId'),
        classRoomId: app.tool.safeReadObjProp(this.choosedList, '0.classRoomId'),
      });
      this.$router.push('/multiModifyClassRoom');
    },
    toModifyReserves() {
      for (let i = 0, len = this.choosedList.length; i<len; i++) {
        let {startTime} = this.choosedList[i];
        if (new Date(startTime)  <= new Date()) {
          this.$dialog.confirm({
            title: '提示',
            message: `请选择未来时间的排课操作修改约课设置`,
            confirmButtonText: "确定",
          })
          .then(() => {})
          .catch((err) => {
            console.log(err);
          });
          return false;
        }
      }
      app.ls.set("multi-modify-reserves-obj", {
        courseArrangeIds: this.arrangeRecordIds,
      });
      this.$router.push('/multiModifyReserve');
    },
  },
  async created () {
    // 修改成功，还原参数，重新请求
    this.$onBus("refresh-multi-edit-page", () => {
      Object.assign(this.params, {...initParams});
      this.firstLoaded = false;
    });
    this.showLoading();
    // 第一次加载，需要所有数据都请求完成
    // 并且全部成功，才会关闭loading状态
    // 否则相应报错会自动替换掉加载状态的toast的(不用再清除了)
    try {
      this.params.classId = this.$route.params.classId;
      // this.list.splice(0);
    
      let res = await this.getFilterData();
      if (res.code === 200) {
        this.$toast.clear();
      }
    } catch (err) {
      console.log(err);
    }
  },
  beforeDestroy() {
    vant.Toast.clear();
  },
  watch:{
    // 选中的条数发生变化(通过单个点击引起)
    choosedNum (v) {
      let len = this.canChoosedNum;
      if (len === 0) {
        this.allChecked = false;
        return false;
      }
      // 当选中条数不等于所有可选条数，取消全选状态
      if (v!==len) this.allChecked = false;
       // 当选中条数等于所有可选条数，标记为全选状态
      if (v===len) this.allChecked = true;
    },
    list (v) {
      let len = this.canChoosedNum;
      if (len === 0) {
        this.allChecked = false;
        return false;
      }
      // 当选中条数不等于所有可选条数，取消全选状态
      if (this.choosedNum!==len) this.allChecked = false;
       // 当选中条数等于所有可选条数，标记为全选状态
      if (this.choosedNum===len) this.allChecked = true;
    },
  },
}
</script>

<style lang="scss" >
.yunxiao.teacher.course-multi-edit{
  .van-dropdown-menu__title{
    padding-right: 16px;
    &::after{
      right: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.yunxiao.teacher.course-multi-edit{
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .sub-top-nav{
    padding: 0 calc(var(--gap) * 16);
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: calc(var(--w) * 44);
    border:1px solid var(--g3);
    background-color: rgba(var(--g1-rgb), 0.49);

    .choose-date{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // font-weight: bold;
      height: calc(var(--w) * 52);
    }

    .time-range{
      display: flex;
      align-items: center;


      .van-icon:first-child{
        margin-right: calc(var(--gap) * 4);
      }
    }
  }
  .course-list{
    position: relative;
    flex: 1;
    background-color: var(--white);
    overflow-y: auto;
    .course-item{
      position: relative;
      padding: calc(var(--gap) * 16) calc(var(--gap) * 64) calc(var(--gap) * 16) calc(var(--gap) * 16);
      color: var(--g6);

      
      .title{
        display: flex;
        justify-content: space-between;
        >span.bold{
          font-size: var(--fs-lg);
          color: var(--g8);
        }
      }
      .infos-nav{
        display: flex;
        margin-top: calc(var(--gap) * 8);
        .infos{
          display: flex;
          flex: 1;
          >div{
            .van-icon {
              color: var(--g8);
              margin-right: calc(var(--gap) * 2);
            }
            display: flex;
            align-items: center;
          }
        }
        .status{
          width: auto;
        }
      }
      .van-checkbox{
        position: absolute;
        width: calc(var(--w) * 18);
        margin: auto;
        right: calc(var(--w) * 18);
        top:0;
        bottom: 0;;
      }

      &::after{
        position: absolute;
        bottom: 0;
        left: calc(var(--gap) * 16);
        right: calc(var(--gap) * 16);
        content: '';
        height: 1px;
        background: var(--g3);
        transform: scaleY(.5);
      }
      &:last-child::after{
        display: none;
      }

      &[time-out="1"] {
        color: var(--g5);
        .title{
          >span.bold{
            font-size: var(--fs-lg);
            color: var(--g5);
          }
        }
        .infos-nav .infos>div .van-icon{
          color: var(--g5);
        }
      }
    }
    >.empty-page{
      z-index: 1;
    }
  }
  .multi-edit-page-footer{
    padding: 0 16px;
    height: 92px;
    border-top: 1px solid var(--g3);
    background-color: var(--white);
    box-sizing: border-box;
    .status-nav{
      display: flex;
      height: 44px;
      align-items: center;
      justify-content: space-between;
      font-size: var(--fs-sm);
      color: var(--g7);
      .total-num{
        display: flex;
        align-items: center;
        .van-popover__wrapper{
          margin: -2px 0 0 3px;
        }
      }
      .choosed-num{
        color: var(--g6);
        >span{
          color: var(--c1);
        }
      }
      .choosed-status{
        display: flex;
        white-space: nowrap;
        .checked-nav{
          margin-left: calc(var(--gap) * 16);
          display: flex;
          white-space: nowrap;
          >div{
            margin-left: calc(var(--gap) * 8);
          }
        }
      }
    }
    >:last-child{
      padding: calc(var(--gap) * 2) 0;
    }
  }
  .delete-dialog {
    .top-tips {
      padding: calc(var(--gap) * 8) calc(var(--gap) * 24) calc(var(--gap) * 24) calc(var(--gap) * 24);
      color: var(--g6);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
    }
  }
}
</style>